import { NamedProperty, SprintQueryResult, useSprintQuery } from "sprint-common-web";

import { useMasterLookupsApi } from "../../api/master-api/lookups/useMasterLookupsApi";
import { LookupDataProvidersQueryKey } from "./LookupDataProvidersQueryKey";

export type AspectType = NamedProperty;

export const useAspectTypes = (): SprintQueryResult<AspectType[]> => {
    const { getAspectTypes } = useMasterLookupsApi();

    return useSprintQuery<AspectType[]>({
        queryKey: [LookupDataProvidersQueryKey.AspectTypes],
        queryFn: async (): Promise<AspectType[]> => {
            const response = await getAspectTypes();
            return response.items;
        }
    });
};
